<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.resFabricRecordStatus === 'D'
              ? 'danger'
              : row.resFabricRecordStatus === 'N'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_resFabricRecordStatus }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="{
                  pageType: 'detail',
                  resFabricRecordCode: row.resFabricRecordCode,
                  resFabricRecordNo: row.resFabricRecordNo,
                  status: row.resFabricRecordStatus,
                }"
              >
                {{ $l('INDEX.btn_view_details') || '查看详情' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit"
                divided
                :command="{
                  pageType: 'edit',
                  resFabricRecordCode: row.resFabricRecordCode,
                  resFabricRecordNo: row.resFabricRecordNo,
                }"
                v-if="allow('M') && row.resFabricRecordStatus != 'D'"
              >
                {{ $l('btn_view_edit') || '编辑单据' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-delete"
                divided
                :command="{
                  pageType: 'del',
                  resFabricRecordCode: row.resFabricRecordCode,
                  resFabricRecordNo: row.resFabricRecordNo,
                }"
                v-if="allow('D') && row.resFabricRecordStatus == 'N'"
              >
                {{ $l('btn_view_del') || '删除单据' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-s-check"
                divided
                :command="{
                  pageType: 'release',
                  resFabricRecordCode: row.resFabricRecordCode,
                  resFabricRecordNo: row.resFabricRecordNo,
                }"
                v-if="allow('P') && row.resFabricRecordStatus == 'N'"
              >
                {{ $l('btn_view_publish') || '发布调研' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    handleCommand(command) {
      const {
        pageType,
        resFabricRecordCode,
        resFabricRecordNo,
        status,
      } = command

      switch (pageType) {
        case 'detail':
          this.$emit('openEditPage', {
            pageType: pageType,
            params: { code: resFabricRecordCode, status: status },
            query: { resFabricRecordNo: resFabricRecordNo },
          })
          break
        case 'edit':
          this.$emit('openEditPage', {
            pageType: pageType,
            params: { code: resFabricRecordCode },
            query: { resFabricRecordNo: resFabricRecordNo },
          })
          break
        case 'del':
          this.del(resFabricRecordCode)
          break
        case 'release':
          this.release(resFabricRecordCode)
          break

        default:
          return
      }
    },
    del(resFabricRecordCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.resFabricRecodeDelApi({ resFabricRecordCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    release(resFabricRecordCode) {
      this.$confirm(
        '是否要发布该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .resFabricRecodeReleaseApi({ resFabricRecordCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: '发布成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
  },
}
</script>
